
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Grid, Paper, Typography, Skeleton, Button } from '@mui/material';
import MDBox from 'components/MDBox';
import TimelapseIcon from '@mui/icons-material/Timelapse';
import MDButton from 'components/MDButton';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import SendTimeExtensionIcon from '@mui/icons-material/SendTimeExtension';
import { getRequestReviewCountAysnc } from "features/actions/auth";



export const ReviewCount = ({ refreshKey }) => {
    const dispatch = useDispatch();
    const business_id = useSelector((state) => state.dashboard.commonId);
    const { requestReviewStats } = useSelector((state) => state.auth);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchRequestReviewData = async () => {
            setLoading(true);

            try {
                if (business_id) {
                    await dispatch(
                        getRequestReviewCountAysnc({
                            business_id: business_id
                        })
                    );
                }
            } catch (error) {
                console.error("Error fetching Request Review:", error);
            } finally {
                setLoading(false);
            }

        };

        fetchRequestReviewData();
    }, [dispatch, business_id, refreshKey]);



    return (
        <MDBox sx={{ p: 2, "@media(max-width:430px)": { p: "4px" } }}>

            <Grid container spacing={2}>

                <Grid item xs={12} sm={6} md={3}>
                    <Paper elevation={0} sx={{ height: '100%', p: 1, borderRadius: '20px' }}>
                        <MDBox sx={{ display: 'flex', py: 1, px: 1.5 }}>
                            <MDBox sx={{
                                backgroundColor: '#F4F7FE',
                                borderRadius: '50%',
                                width: 50,
                                height: 50,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mr: 1,
                                fontSize: '28px'
                            }}>

                                <SendTimeExtensionIcon sx={{ color: '#318BEC', }} />
                            </MDBox>
                            <MDBox my="auto">
                                <Typography sx={{
                                    fontWeight: 600, fontSize: '16px', lineHeight: '19px',
                                    color: '#707EAE', fontFamily: 'Urbanist'
                                }}>
                                    No of review requests
                                </Typography>
                                <Typography sx={{
                                    fontWeight: 700, fontSize: '24px', lineHeight: '32px',
                                    color: '#292929', fontFamily: 'Urbanist'
                                }}>
                                    {loading ? (
                                        <Skeleton width={100} height={17} sx={{ mt: '5px', borderRadius: '5px' }} />
                                    ) : (
                                        requestReviewStats.total_requests || 0
                                    )}
                                </Typography>
                            </MDBox>
                        </MDBox>
                    </Paper>
                </Grid>

                {/* Average Rating */}
                <Grid item xs={12} sm={6} md={3}>
                    <Paper elevation={0} sx={{ height: '100%', p: 1, borderRadius: '20px' }}>
                        <MDBox sx={{ display: 'flex', py: 1, px: 1.5 }}>
                            <MDBox sx={{
                                backgroundColor: '#F4F7FE',
                                borderRadius: '50%',
                                width: 50,
                                height: 50,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mr: 1,
                                boxSizing: 'border-box'
                            }}>

                                <VerifiedUserIcon sx={{ color: '#318BEC', fontSize: '28px' }} />
                            </MDBox>
                            <MDBox my="auto">
                                <Typography sx={{
                                    fontWeight: 600, fontSize: '16px', lineHeight: '19px',
                                    color: '#707EAE', fontFamily: 'Urbanist'
                                }}>
                                    No of review requests clicked
                                </Typography>
                                <Typography sx={{
                                    fontWeight: 700, fontSize: '24px', lineHeight: '32px',
                                    color: '#292929', fontFamily: 'Urbanist'
                                }}>
                                    {loading ? (
                                        <Skeleton width={50} height={10} sx={{ mt: '5px', borderRadius: '5px' }} />
                                    ) : (
                                        requestReviewStats.total_done || 0
                                    )}
                                </Typography>
                            </MDBox>
                        </MDBox>
                    </Paper>
                </Grid>

                {/* Average Food Rating */}
                <Grid item xs={12} sm={6} md={3}>
                    <Paper elevation={0} sx={{ height: '100%', p: 1, borderRadius: '20px' }}>
                        <MDBox sx={{ display: 'flex', py: 1, px: 1.5 }}>
                            <MDBox sx={{
                                backgroundColor: '#F4F7FE',
                                borderRadius: '50%',
                                width: 50,
                                height: 50,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mr: 1,
                                fontSize: '28px'
                            }}>

                                <TimelapseIcon sx={{ color: '#318BEC'}} />
                            </MDBox>
                            <MDBox my="auto">
                                <Typography sx={{
                                    fontWeight: 600, fontSize: '16px', lineHeight: '19px',
                                    color: '#707EAE', fontFamily: 'Urbanist'
                                }}>
                                    No of Request Pending
                                </Typography>
                                <Typography sx={{
                                    fontWeight: 700, fontSize: '24px', lineHeight: '32px',
                                    color: '#292929', fontFamily: 'Urbanist'
                                }}>
                                    {loading ? (
                                        <Skeleton width={50} height={10} sx={{ mt: '5px', borderRadius: '5px' }} />
                                    ) : (
                                        requestReviewStats.total_pending || 0
                                    )}
                                </Typography>
                            </MDBox>
                        </MDBox>
                    </Paper>
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <Paper elevation={0} sx={{ height: '100%', p: 1, borderRadius: '20px' }}>
                        <MDBox sx={{ display: 'flex', py: 1, px: 1.5 }}>
                            <MDBox sx={{
                                backgroundColor: '#F4F7FE',
                                borderRadius: '50%',
                                width: 50,
                                height: 50,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                mr: 1,
                                fontSize: '28px'
                            }}>

                                <TimelapseIcon sx={{ color: '#318BEC', fontSize: 35 }} />
                            </MDBox>
                            <MDBox my="auto">
                                <Typography sx={{
                                    fontWeight: 600, fontSize: '16px', lineHeight: '19px',
                                    color: '#707EAE', fontFamily: 'Urbanist'
                                }}>
                                    No of Scanned Request
                                </Typography>
                                <Typography sx={{
                                    fontWeight: 700, fontSize: '24px', lineHeight: '32px',
                                    color: '#292929', fontFamily: 'Urbanist'
                                }}>
                                    {loading ? (
                                        <Skeleton width={50} height={10} sx={{ mt: '5px', borderRadius: '5px' }} />
                                    ) : (
                                        requestReviewStats.generic_number_of_requests|| 0
                                    )}
                                </Typography>
                            </MDBox>
                        </MDBox>
                    </Paper>
                </Grid>
            </Grid>
            
        </MDBox>

    );
};
